function handleCookiePolicy() {
  const cookiePopup = document.querySelector(".js-cookie-popup");
  if (!cookiePopup) return;

  const cookieService = document.getElementById("CybotCookiebotDialog");
  if (!cookieService) {
    cookiePopup.classList.add("is-active");
    return;
  }
  cookieService.style.display = "none";

  const acceptBtn = document.getElementById("CybotCookiebotDialogBodyButtonAccept");
  if (!acceptBtn) {
    cookiePopup.classList.add("is-active");
    return;
  }

  const declineBtn = document.getElementById("CybotCookiebotDialogBodyButtonDecline");
  const acceptBtnTrigger = document.querySelector(".js-cookie-accept");
  const declineBtnTrigger = document.querySelector(".js-cookie-decline");
  if (acceptBtnTrigger && acceptBtn) {
    acceptBtnTrigger.addEventListener("click", () => {
      cookiePopup.classList.add("is-active");
      acceptBtn.click();
    });
  }
  if (declineBtnTrigger && declineBtn) {
    declineBtnTrigger.addEventListener("click", () => {
      cookiePopup.classList.add("is-active");
      declineBtn.click();
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  handleCookiePolicy();
});
